<template>
  <div class="paResumeList">
    <van-notice-bar wrapable :scrollable="false">
      人职派单可直接推荐，请在PC端操作！
    </van-notice-bar>
    <van-list
      v-if="(list && list.length) || loading"
		  v-model="loading"
		  :finished="finished"
		  finished-text="没有更多了"
		  @load="onLoad"
		>
		  <list v-for="item in list" :item="item"></list>
		</van-list>
    <no-data v-else></no-data>
  </div>
</template>

<script>

import List from '@/components/pa/list'
import {getResumePositionList} from '@/api/pa'
import {getPositionTags, getPositionStatistics} from '@/api/positions'
import NoData from "@/components/noData";

export default {
  name: "paResumeList",
  data(){
  	return {
  		list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10
  	}
  },
  components: {
  	List,NoData
  },
  methods: {
  	onLoad(){
      this.loading = true;
      let params = {pageNo:this.pageNo, pageSize: this.pageSize};
      getResumePositionList(params).then(res=>{
        let curIds = [];
        if(res.data){

          curIds = res.data.list.map(item=>item.positionId) || [];
          res.data.list.forEach(item=>{
            item.positionTags = [];
            item.statics = {};
          })

          this.list = this.list.concat(res.data.list||[]);
          this.pageNo++;
          if(res.data.list.length<this.pageSize)
            this.finished = true;
        }else{
          this.finished = true;
        }
        
        if(curIds && curIds.length){
          this.positionTags(curIds);
          this.positionStatistics(curIds);
        }
      }).catch(err=>{}).finally(()=>{this.loading = false;})
  	},
    positionTags(curIds){
      getPositionTags({positionIds: curIds.join(',')}).then(res=>{
        this.list.forEach(item=>{
          if(res.data[item.positionId]){
            item.positionTags = res.data[item.positionId];  
          }
        })
      }).catch(err=>{})
    },
    positionStatistics(curIds){
      getPositionStatistics({positionIds: curIds.join(',')}).then(res=>{
        this.list.forEach(item=>{
          if(res.data[item.positionId]){
            item.statics = res.data[item.positionId];  
          }
        })
      }).catch(err=>{})
    }
  },
  created() {
    this.onLoad();
  }
};
</script>

<style lang="scss">
  .van-list{
    background: #f5f5f5;
  }
</style>
